import request from '@/utils/request';

export function newMemberDetail() {
  return request({
    url: '/Welfare/newMemberDetail',
  });
}

export function receiveWelfareNewMemberGift(data) {
  return request({
    url: '/Welfare/newMemberReceiveGift',
    method: 'POST',
    data,
  });
}
